import {
  COMPLAINT_REQUIREMENT_LIST_REQUEST,
  COMPLAINT_REQUIREMENT_LIST_SUCCESS,
  COMPLAINT_REQUIREMENT_LIST_FAIL,
  COMPLAINT_REQUIREMENT_LIST_RESET,
  COMPLAINT_REQUIREMENT_SINGLE_REQUEST,
  COMPLAINT_REQUIREMENT_SINGLE_SUCCESS,
  COMPLAINT_REQUIREMENT_SINGLE_FAIL,
  COMPLAINT_REQUIREMENT_SINGLE_RESET,
  CREATE_COMPLAINT_REQUIREMENT_REQUEST,
  CREATE_COMPLAINT_REQUIREMENT_SUCCESS,
  CREATE_COMPLAINT_REQUIREMENT_FAIL,
  CREATE_COMPLAINT_REQUIREMENT_RESET,
  UPDATE_COMPLAINT_REQUIREMENT_REQUEST,
  UPDATE_COMPLAINT_REQUIREMENT_SUCCESS,
  UPDATE_COMPLAINT_REQUIREMENT_FAIL,
  UPDATE_COMPLAINT_REQUIREMENT_RESET,
  DELETE_COMPLAINT_REQUIREMENT_REQUEST,
  DELETE_COMPLAINT_REQUIREMENT_SUCCESS,
  DELETE_COMPLAINT_REQUIREMENT_FAIL,
  DELETE_COMPLAINT_REQUIREMENT_RESET,
} from "constants/complaintRequirementConstants";

export const listComplaintRequirementsReducer = (
  state = { complaintRequirementList: [] },
  action
) => {
  switch (action.type) {
    case COMPLAINT_REQUIREMENT_LIST_REQUEST:
      return { loading: true };
    case COMPLAINT_REQUIREMENT_LIST_SUCCESS:
      return { loading: false, complaintRequirementList: action.payload };
    case COMPLAINT_REQUIREMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    case COMPLAINT_REQUIREMENT_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const singleComplaintRequirementsReducer = (
  state = { complaintRequirementSingle: {} },
  action
) => {
  switch (action.type) {
    case COMPLAINT_REQUIREMENT_SINGLE_REQUEST:
      return { loading: true };
    case COMPLAINT_REQUIREMENT_SINGLE_SUCCESS:
      return { loading: false, complaintRequirementSingle: action.payload };
    case COMPLAINT_REQUIREMENT_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case COMPLAINT_REQUIREMENT_SINGLE_RESET:
      return [];
    default:
      return state;
  }
};

export const complaintRequirementCreateReducer = (
  state = { newComplaintRequirement: {} },
  action
) => {
  switch (action.type) {
    case CREATE_COMPLAINT_REQUIREMENT_REQUEST:
      return { loading: true };
    case CREATE_COMPLAINT_REQUIREMENT_SUCCESS:
      return { loading: false, newComplaintRequirement: action.payload };
    case CREATE_COMPLAINT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_COMPLAINT_REQUIREMENT_RESET:
      return { newComplaintRequirement: {} };
    default:
      return state;
  }
};

export const complaintRequirementUpdateReducer = (
  state = { updateComplaintRequirement: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_COMPLAINT_REQUIREMENT_REQUEST:
      return { loading: true };
    case UPDATE_COMPLAINT_REQUIREMENT_SUCCESS:
      return {
        loading: false,
        updateComplaintRequirement: action.payload,
        success: true,
      };
    case UPDATE_COMPLAINT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_COMPLAINT_REQUIREMENT_RESET:
      return { updateComplaintRequirement: {} };
    default:
      return state;
  }
};

export const complaintRequirementDeleteReducer = (
  state = { deleteComplaintRequirement: {} },
  action
) => {
  switch (action.type) {
    case DELETE_COMPLAINT_REQUIREMENT_REQUEST:
      return { loading: true };
    case DELETE_COMPLAINT_REQUIREMENT_SUCCESS:
      return {
        loading: false,
        deleteComplaintRequirement: action.payload,
        success: true,
      };
    case DELETE_COMPLAINT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_COMPLAINT_REQUIREMENT_RESET:
      return { deleteComplaintRequirement: {} };
    default:
      return state;
  }
};
